"use client";

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "@tillix/ui-atoms/i18n";
// Bundled translations — eliminates HTTP latency and build-time fetch issues.
// English
import enErrors from "@tillix/ui-atoms/i18n/namespaces/en/errors.json";
import enFeatures from "@tillix/ui-atoms/i18n/namespaces/en/features.json";
import enInputs from "@tillix/ui-atoms/i18n/namespaces/en/inputs.json";
import enUi from "@tillix/ui-atoms/i18n/namespaces/en/ui.json";
// Spanish
import esErrors from "@tillix/ui-atoms/i18n/namespaces/es/errors.json";
import esFeatures from "@tillix/ui-atoms/i18n/namespaces/es/features.json";
import esInputs from "@tillix/ui-atoms/i18n/namespaces/es/inputs.json";
import esUi from "@tillix/ui-atoms/i18n/namespaces/es/ui.json";
// Korean
import koErrors from "@tillix/ui-atoms/i18n/namespaces/ko/errors.json";
import koFeatures from "@tillix/ui-atoms/i18n/namespaces/ko/features.json";
import koInputs from "@tillix/ui-atoms/i18n/namespaces/ko/inputs.json";
import koUi from "@tillix/ui-atoms/i18n/namespaces/ko/ui.json";
// Chinese (Simplified)
import zhErrors from "@tillix/ui-atoms/i18n/namespaces/zh/errors.json";
import zhFeatures from "@tillix/ui-atoms/i18n/namespaces/zh/features.json";
import zhInputs from "@tillix/ui-atoms/i18n/namespaces/zh/inputs.json";
import zhUi from "@tillix/ui-atoms/i18n/namespaces/zh/ui.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const I18NEXT_DEBUG = process.env.NEXT_PUBLIC_I18NEXT_DEBUG === "true";

void i18n.use(initReactI18next).init({
  resources: {
    en: { ui: enUi, inputs: enInputs, errors: enErrors, features: enFeatures },
    es: { ui: esUi, inputs: esInputs, errors: esErrors, features: esFeatures },
    zh: { ui: zhUi, inputs: zhInputs, errors: zhErrors, features: zhFeatures },
    ko: { ui: koUi, inputs: koInputs, errors: koErrors, features: koFeatures },
  },
  supportedLngs: [...SUPPORTED_LANGUAGES],
  fallbackLng: DEFAULT_LANGUAGE,
  lng: DEFAULT_LANGUAGE, // initial language; overridden by useT via changeLanguage()
  load: "languageOnly",
  defaultNS: "ui",
  interpolation: {
    escapeValue: false,
  },
  debug: process.env.NODE_ENV === "development" && I18NEXT_DEBUG,
});

export default i18n;
